import React, { useState, useEffect } from 'react';

const HoliDiscount = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  // Countdown to Holi offer end (March 15, 2026)
  useEffect(() => {
    const targetDate = new Date('2026-03-15T23:59:59').getTime();

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000)
        });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const holiColors = [
    '#FF1493', '#FF6B35', '#FFD700', '#00E676',
    '#7C4DFF', '#00BCD4', '#FF4081', '#FFEB3B',
    '#E040FB', '#76FF03', '#F44336', '#2196F3'
  ];

  // Floating color powder particles
  const particles = Array.from({ length: 55 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 8,
    duration: 6 + Math.random() * 6,
    size: 6 + Math.random() * 18,
    color: holiColors[i % holiColors.length],
    blur: Math.random() > 0.4 ? `${1 + Math.random() * 3}px` : '0px',
  }));

  // Color splash blobs
  const splashes = Array.from({ length: 14 }, (_, i) => ({
    id: i,
    left: 3 + Math.random() * 94,
    top: 3 + Math.random() * 94,
    size: 50 + Math.random() * 100,
    color: holiColors[i % holiColors.length],
    delay: Math.random() * 5,
    duration: 4 + Math.random() * 4,
  }));

  return (
    <div style={styles.container}>

      {/* Floating Gulal Particles */}
      {particles.map((p) => (
        <div
          key={`p-${p.id}`}
          style={{
            position: 'absolute',
            bottom: '-20px',
            left: `${p.left}%`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            borderRadius: '50%',
            background: p.color,
            filter: `blur(${p.blur})`,
            opacity: 0.75,
            animation: `holi-floatUp ${p.duration}s linear ${p.delay}s infinite`,
            pointerEvents: 'none',
            zIndex: 1,
          }}
        />
      ))}

      {/* Background Splash Blobs */}
      {splashes.map((s) => (
        <div
          key={`s-${s.id}`}
          style={{
            position: 'absolute',
            left: `${s.left}%`,
            top: `${s.top}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            borderRadius: '50%',
            background: `radial-gradient(circle, ${s.color}55, ${s.color}00)`,
            animation: `holi-splash ${s.duration}s ease-in-out ${s.delay}s infinite`,
            pointerEvents: 'none',
            zIndex: 1,
          }}
        />
      ))}

      {/* Pichkari Left */}
      <div style={styles.decoLeft}>
        <svg width="60" height="60" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" style={{ animation: 'holi-deco 3s ease-in-out infinite' }}>
          <rect x="8" y="50" width="60" height="18" rx="9" fill="#FF6B35" />
          <rect x="62" y="42" width="14" height="34" rx="5" fill="#7C4DFF" />
          <circle cx="90" cy="42" r="10" fill="#FF1493" opacity="0.7" />
          <circle cx="100" cy="56" r="12" fill="#00E676" opacity="0.6" />
          <circle cx="88" cy="65" r="9" fill="#FFD700" opacity="0.7" />
          <circle cx="105" cy="45" r="7" fill="#00BCD4" opacity="0.6" />
        </svg>
      </div>

      {/* Pichkari Right */}
      <div style={styles.decoRight}>
        <svg width="60" height="60" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" style={{ animation: 'holi-deco 3s ease-in-out infinite 0.5s', transform: 'scaleX(-1)' }}>
          <rect x="8" y="50" width="60" height="18" rx="9" fill="#E040FB" />
          <rect x="62" y="42" width="14" height="34" rx="5" fill="#00BCD4" />
          <circle cx="90" cy="42" r="10" fill="#FFD700" opacity="0.7" />
          <circle cx="100" cy="56" r="12" fill="#FF4081" opacity="0.6" />
          <circle cx="88" cy="65" r="9" fill="#7C4DFF" opacity="0.7" />
          <circle cx="105" cy="45" r="7" fill="#76FF03" opacity="0.6" />
        </svg>
      </div>

      {/* Rainbow Top Border */}
      <div style={styles.rainbowBorder}>
        <div style={{ flex: 1, background: '#FF1493' }}></div>
        <div style={{ flex: 1, background: '#FF6B35' }}></div>
        <div style={{ flex: 1, background: '#FFD700' }}></div>
        <div style={{ flex: 1, background: '#00E676' }}></div>
        <div style={{ flex: 1, background: '#00BCD4' }}></div>
        <div style={{ flex: 1, background: '#7C4DFF' }}></div>
        <div style={{ flex: 1, background: '#E040FB' }}></div>
      </div>

      {/* ===== Main Content ===== */}
      <div style={styles.content}>

        {/* Badge */}
        <div style={styles.badge}>
          <span style={{ fontSize: '20px' }}>🎨</span>
          <span>Holi Special Offer</span>
          <span style={{ fontSize: '20px' }}>🎨</span>
        </div>

        {/* Heading */}
        <h2 style={styles.heading}>
          <span style={styles.sparkle}>💥</span>
          Happy Holi
          <span style={styles.sparkle}>💥</span>
        </h2>

        {/* Sub heading */}
        <p style={styles.subHeading}>Festival of Colors Discount!</p>

        {/* Gulal Dots */}
        <div style={styles.gulalRow}>
          {['#FF1493', '#FFD700', '#00E676', '#7C4DFF', '#00BCD4', '#FF6B35', '#E040FB'].map((c, i) => (
            <div key={i} style={{
              width: '14px',
              height: '14px',
              borderRadius: '50%',
              background: c,
              boxShadow: `0 0 12px ${c}`,
              animation: `holi-gulalPop 1.8s ease-in-out ${i * 0.2}s infinite`,
            }} />
          ))}
        </div>

        {/* Discount Box */}
        <div style={styles.discountWrapper}>
          <div style={styles.discountBox}>
            <div style={styles.discountLabel}>FLAT</div>
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
              <span style={styles.discountNumber}>20</span>
              <span style={styles.discountPercent}>%</span>
            </div>
            <div style={styles.discountOff}>OFF</div>
          </div>
        </div>

        {/* Sub Text */}
        <p style={styles.subText}>
          🎉 On <strong>ALL Courses</strong> at LogicMojo 🎉
        </p>

        {/* Quote */}
        <p style={styles.quote}>
          "Add colors of knowledge to your career this Holi"
        </p>

      

      </div>

      {/* Rainbow Bottom Border */}
      <div style={styles.rainbowBorderBottom}>
        <div style={{ flex: 1, background: '#FF1493' }}></div>
        <div style={{ flex: 1, background: '#FF6B35' }}></div>
        <div style={{ flex: 1, background: '#FFD700' }}></div>
        <div style={{ flex: 1, background: '#00E676' }}></div>
        <div style={{ flex: 1, background: '#00BCD4' }}></div>
        <div style={{ flex: 1, background: '#7C4DFF' }}></div>
        <div style={{ flex: 1, background: '#E040FB' }}></div>
      </div>

      {/* ===== Keyframes ===== */}
      <style>{`
        @keyframes holi-floatUp {
          0%   { transform: translateY(0) rotate(0deg) scale(0.5); opacity: 0; }
          8%   { opacity: 0.85; }
          50%  { transform: translateY(-50vh) rotate(200deg) scale(1.2); opacity: 0.7; }
          100% { transform: translateY(-105vh) rotate(400deg) scale(0.3); opacity: 0; }
        }

        @keyframes holi-splash {
          0%, 100% { transform: scale(1); opacity: 0.25; }
          30%  { transform: scale(1.6); opacity: 0.45; }
          60%  { transform: scale(0.8); opacity: 0.2; }
          80%  { transform: scale(1.3); opacity: 0.35; }
        }

        @keyframes holi-pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }

        @keyframes holi-shimmer {
          0%   { background-position: -200% center; }
          100% { background-position: 200% center; }
        }

        @keyframes holi-glow {
          0%, 100% {
            box-shadow: 0 0 25px rgba(255,20,147,0.5), 0 0 50px rgba(124,77,255,0.3), 0 0 75px rgba(255,215,0,0.15);
          }
          33% {
            box-shadow: 0 0 30px rgba(124,77,255,0.55), 0 0 55px rgba(0,230,118,0.35), 0 0 80px rgba(255,20,147,0.2);
          }
          66% {
            box-shadow: 0 0 28px rgba(0,230,118,0.5), 0 0 52px rgba(255,215,0,0.35), 0 0 78px rgba(124,77,255,0.2);
          }
        }

        @keyframes holi-deco {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          25%  { transform: translateY(-8px) rotate(5deg); }
          50%  { transform: translateY(-14px) rotate(0deg); }
          75%  { transform: translateY(-8px) rotate(-5deg); }
        }

        @keyframes holi-sparkle {
          0%, 100% { opacity: 1; transform: scale(1) rotate(0deg); }
          25%  { opacity: 0.7; transform: scale(1.25) rotate(12deg); }
          50%  { opacity: 0.5; transform: scale(1.35) rotate(0deg); }
          75%  { opacity: 0.8; transform: scale(1.15) rotate(-12deg); }
        }

        @keyframes holi-gulalPop {
          0%, 100% { transform: scale(1); opacity: 0.8; }
          50%  { transform: scale(1.5); opacity: 1; }
        }

        @keyframes holi-colorCycle {
          0%   { color: #FF1493; }
          14%  { color: #FF6B35; }
          28%  { color: #FFD700; }
          42%  { color: #00E676; }
          57%  { color: #00BCD4; }
          71%  { color: #7C4DFF; }
          85%  { color: #E040FB; }
          100% { color: #FF1493; }
        }

        @keyframes holi-bgShift {
          0%   { background-position: 0% 50%; }
          50%  { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        @keyframes holi-borderColor {
          0%   { border-color: #FF1493; }
          25%  { border-color: #FFD700; }
          50%  { border-color: #00E676; }
          75%  { border-color: #7C4DFF; }
          100% { border-color: #FF1493; }
        }

        @keyframes holi-headingGlow {
          0%, 100% { text-shadow: 2px 2px 10px rgba(255,20,147,0.5), 0 0 40px rgba(124,77,255,0.3); }
          33%  { text-shadow: 2px 2px 10px rgba(255,215,0,0.5), 0 0 40px rgba(0,230,118,0.3); }
          66%  { text-shadow: 2px 2px 10px rgba(0,188,212,0.5), 0 0 40px rgba(255,107,53,0.3); }
        }
      `}</style>
    </div>
  );
};

const styles = {
  container: {
    position: 'relative',
    overflow: 'hidden',
    background: 'linear-gradient(135deg, #1a0a2e 0%, #2d1b4e 25%, #1a1a3e 50%, #0f2460 75%, #1a0a2e 100%)',
    backgroundSize: '400% 400%',
    animation: 'holi-bgShift 10s ease infinite',
    padding: '60px 20px',
    borderRadius: '20px',
    margin: '20px',
    boxShadow: '0 20px 60px rgba(124, 77, 255, 0.25), 0 0 80px rgba(255, 20, 147, 0.1)',
    border: '3px solid rgba(255, 20, 147, 0.35)',
  },
  decoLeft: {
    position: 'absolute',
    left: '15px',
    top: '25px',
    zIndex: 2,
  },
  decoRight: {
    position: 'absolute',
    right: '15px',
    top: '25px',
    zIndex: 2,
  },
  rainbowBorder: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '6px',
    display: 'flex',
    borderRadius: '20px 20px 0 0',
    overflow: 'hidden',
  },
  rainbowBorderBottom: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '6px',
    display: 'flex',
    borderRadius: '0 0 20px 20px',
    overflow: 'hidden',
  },
  content: {
    position: 'relative',
    zIndex: 10,
    textAlign: 'center',
    maxWidth: '800px',
    margin: '0 auto',
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '10px',
    background: 'linear-gradient(90deg, #FF1493, #FFD700, #00E676, #7C4DFF, #E040FB, #FF1493)',
    backgroundSize: '300% auto',
    animation: 'holi-shimmer 4s linear infinite',
    padding: '10px 28px',
    borderRadius: '50px',
    color: '#1a0a2e',
    fontWeight: 'bold',
    fontSize: '14px',
    textTransform: 'uppercase',
    letterSpacing: '2px',
    marginBottom: '20px',
    boxShadow: '0 4px 20px rgba(255, 20, 147, 0.35), 0 4px 20px rgba(124, 77, 255, 0.25)',
  },
  heading: {
    fontSize: 'clamp(32px, 6vw, 52px)',
    color: '#ffffff',
    margin: '0 0 10px 0',
    fontWeight: '800',
    animation: 'holi-headingGlow 4s ease-in-out infinite',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '15px',
    flexWrap: 'wrap',
  },
  sparkle: {
    animation: 'holi-sparkle 1.8s ease-in-out infinite',
    fontSize: 'clamp(26px, 4vw, 40px)',
  },
  subHeading: {
    fontSize: 'clamp(18px, 3vw, 26px)',
    color: 'rgba(255,255,255,0.9)',
    margin: '0 0 18px 0',
    fontWeight: '600',
    animation: 'holi-colorCycle 5s linear infinite',
    letterSpacing: '1px',
  },
  gulalRow: {
    display: 'flex',
    justifyContent: 'center',
    gap: '14px',
    marginBottom: '24px',
    flexWrap: 'wrap',
  },
  discountWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '25px',
  },
  discountBox: {
    background: 'linear-gradient(135deg, #FF1493 0%, #7C4DFF 35%, #E040FB 65%, #FFD700 100%)',
    backgroundSize: '300% 300%',
    animation: 'holi-pulse 2s ease-in-out infinite, holi-glow 3s ease-in-out infinite, holi-bgShift 5s ease infinite',
    padding: '25px 50px',
    borderRadius: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    border: '4px solid #FFD700',
  },
  discountLabel: {
    color: '#fff',
    fontSize: '20px',
    fontWeight: '700',
    letterSpacing: '3px',
    textShadow: '1px 1px 4px rgba(0,0,0,0.4)',
  },
  discountNumber: {
    fontSize: 'clamp(55px, 10vw, 85px)',
    fontWeight: '900',
    color: '#fff',
    lineHeight: 1,
    textShadow: '3px 3px 0 rgba(0,0,0,0.3), 0 0 25px rgba(255,215,0,0.4)',
  },
  discountPercent: {
    fontSize: 'clamp(26px, 5vw, 40px)',
    fontWeight: '800',
    color: '#FFD700',
    marginTop: '5px',
    textShadow: '1px 1px 0 rgba(0,0,0,0.3)',
  },
  discountOff: {
    color: '#fff',
    fontSize: '20px',
    fontWeight: '700',
    letterSpacing: '3px',
    textShadow: '1px 1px 4px rgba(0,0,0,0.4)',
  },
  subText: {
    fontSize: 'clamp(18px, 3vw, 24px)',
    color: '#ffffff',
    margin: '0 0 15px 0',
    textShadow: '1px 1px 5px rgba(0,0,0,0.3)',
  },
  quote: {
    fontSize: '17px',
    color: 'rgba(255,255,255,0.85)',
    fontStyle: 'italic',
    margin: '0 0 30px 0',
    animation: 'holi-colorCycle 7s linear infinite',
  },
  timerSection: {
    marginBottom: '10px',
  },
  timerLabel: {
    color: '#FFD700',
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '15px',
    letterSpacing: '1px',
  },
  timerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap',
  },
  timerBox: {
    background: 'rgba(0,0,0,0.4)',
    backdropFilter: 'blur(10px)',
    padding: '15px 20px',
    borderRadius: '12px',
    minWidth: '70px',
    border: '2px solid rgba(255,20,147,0.35)',
    boxShadow: '0 4px 15px rgba(124,77,255,0.15)',
    animation: 'holi-borderColor 4s linear infinite',
  },
  timerValue: {
    display: 'block',
    fontSize: 'clamp(24px, 5vw, 36px)',
    fontWeight: '800',
    color: '#fff',
    fontFamily: 'monospace',
  },
  timerUnit: {
    display: 'block',
    fontSize: '11px',
    color: '#FF1493',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    marginTop: '5px',
  },
  timerSeparator: {
    fontSize: '30px',
    fontWeight: 'bold',
    color: '#FFD700',
  },
};

export default HoliDiscount;
